import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { supabase } from "../lib/supabase";
import { Card, Button, useToast, EmptyState, PageHeader, PageLayout } from "@dawa/ui";
import { Skeleton } from "@dawa/ui";
import { apiFetch } from "../lib/api";

export default function History() {
  const [revisions, setRevisions] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const { addToast, Toasts } = useToast();
  const [params] = useSearchParams();
  const id = params.get("contentId");
  useEffect(() => {
    if (!id) return;
    (async () => {
      const s = await supabase.auth.getSession();
      const token = s.data.session?.access_token;
      const r = await apiFetch(`/v1/revisions?contentId=${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!r.ok) {
        addToast(`Erreur ${r.status} au chargement des révisions`, "error");
        setRevisions([]);
      } else {
        const j = await r.json().catch(() => []);
        setRevisions(Array.isArray(j) ? j : []);
      }
      setLoading(false);
    })();
  }, [id]);
  async function restore(rev: any) {
    const s = await supabase.auth.getSession();
    const token = s.data.session?.access_token;
    try {
      const res = await apiFetch(`/v1/contents/${id}`, {
        method: "PATCH",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body: JSON.stringify({ article_md: rev.article_md }),
      });
      if (!res.ok) throw new Error(`Erreur ${res.status}`);
      addToast("Version restaurée", "success");
    } catch (e) {
      addToast(e instanceof Error ? e.message : String(e), "error");
    }
  }
  return (
    <PageLayout maxWidth="full" className="space-y-4">
      <PageHeader
        title="Historique"
        breadcrumbs={id ? [{ label: "Contenu", href: `/content/${id}` }, { label: "Historique" }] : [{ label: "Historique" }]}
        subtitle="Restaurez une version précédente de votre contenu."
      />
      {loading ? (
        <Card className="p-4">
          <Skeleton lines={4} />
        </Card>
      ) : revisions.length === 0 ? (
        <EmptyState title="Aucune révision" description="Lorsque vous enregistrerez des versions, elles apparaîtront ici pour restauration." />
      ) : (
        revisions.map((r) => (
          <Card key={r.id} className="space-y-2 p-4">
            <div className="flex items-center justify-between">
              <div className="text-sm text-text">{new Date(r.created_at).toLocaleString()}</div>
              {r.note && <div className="text-xs text-muted">{r.note}</div>}
            </div>
            <div className="text-sm text-muted whitespace-pre-line">
              {r.article_md?.slice(0, 200)}
            </div>
            <div>
              <Button onClick={() => void restore(r)}>Restaurer</Button>
            </div>
          </Card>
        ))
      )}
      <Toasts />
    </PageLayout>
  );
}
